module.exports = __webpack_public_path__ + "static/media/logo-nih-on.612dc82b.svg";